// extracted by mini-css-extract-plugin
export default {"date-badge":"DateBadge_date-badge__POIWe"};